import React from 'react';
import { CheckBox } from '@material-ui/icons';
import FormConfigMultiSelect from '../../config/FormConfigMultiSelect';
import { FormMultiSelect } from '../../fields/FormMultiSelect';
import { FormConfigLayoutGrid } from '../../config/FormConfigLayoutGrid';
export const FormMultiSelectPlugin = {
    icon: React.createElement(CheckBox, null),
    name: 'Checkboxes',
    type: 'MultiSelect',
    dataTypes: ['text', 'integer', 'numeric', 'enum'],
    dataArray: true,
    configurator: FormConfigMultiSelect,
    layoutConfigurator: () => React.createElement(FormConfigLayoutGrid, null),
    element: FormMultiSelect
};
//# sourceMappingURL=FormMultiSelectPlugin.js.map